import React from 'react';
import { unhyphenate } from './../../helpers/common/stringUtils';

export function validate( evt, type, name, fields ){
    return fields.map( field => {
        if( field.name !== name || !field.required ){ return field };

        const value = evt.target.value;

        switch( type ){
            case "text":
                field.valid = !!value;
                field.invalidMsg = `${ unhyphenate( name ) } is a required field`;
            break;
            case "email":
                field.valid = !!value && value.indexOf('@') > -1 && value.indexOf('.') > -1 && value.length > 3;
                field.invalidMsg = 'EMAIL IS A REQUIRED FIELD';
            break;
            case "number":
                field.valid = !!value && /^[0-9]*$/gm.test( value );
                field.invalidMsg = `PHONE NUMBER IS A REQUIRED FIELD`;
            break;
        };

        if( field.valid ){ field.value = value };
        return field;
    });
};

export function isValid( arr ){
    return !arr.every( field => field.valid ) || !arr.filter( field => !!field.required ).every( field => !!field.value );
};

export function getField( field, validate ){

    const validateFnc = validate ? {onBlur : evt => validate( evt, field.type, field.name )} : {};

    const tag = () => {
        switch( field.tagName ){
            case "input":
                const extras = field.type !== 'number' ? {} : { onKeyDown : evt => evt.keyCode == 69 && evt.preventDefault() } ;// fix for number field allowing the character 'e'
                return <input className="form-input" type={ field.type } name={ field.name } id={ field.name } placeholder={ field.placeholder || "" } defaultValue={ field.defaultValue || null } { ...(validateFnc) } { ...extras }/>;
            case "textarea":
                return <textarea className="form-textarea" name={ field.name } id={ field.name } placeholder={ field.placeholder || "" } { ...(validateFnc) } defaultValue={ field.defaultValue || "" }/>
        };
    };

    const invalidMsg = () => {
        if( field.valid ){ return };
        if( field.invalidMsg ){ return <span className="error-message">{ field.invalidMsg }</span> };
    };

    return (
        <div key={ field.name } className={ field.classOveride ? field.classOveride : "col-12 col-lg-6 form-group alt" }>
            <label className="form-label" htmlFor={ field.name }>{ field.label }</label>
            { tag() }
            { invalidMsg() }
        </div>
    );

};



// WEBPACK FOOTER //
// src/client/helpers/common/form.js